import { enumKeys } from "@app/shared";
import { PropsWithChildren } from "react";

type FlagEnumCheckboxProps<T> = {
    enumType: T,
    keyFilter?: (key: string | number) => boolean,
    nameToDisplayConverter?: (key: string & keyof T) => string | undefined,
    value: (number | undefined),
    onChange: (val: (number | undefined)) => void,
    sort?: boolean
};

export const FlagEnumCheckboxInput = <T extends { [key: string]: number | string }>(props: PropsWithChildren<FlagEnumCheckboxProps<T>>) => {
    const { enumType, nameToDisplayConverter, keyFilter, onChange, value } = props;
    var allKeys = enumKeys(enumType).filter((k) => !keyFilter || keyFilter(enumType[k]));
    if (props.sort) {
        allKeys = allKeys.sort();
    }
    return (
        allKeys.map((t) => (
            <div key={t} className="flex flex-row place-items-center gap-2">
                <label>
                    <input
                        className="border-0 shadow-none w-8"
                        type="checkbox"
                        onChange={(e) => {
                            if (!e.target.checked && (props.value === null || props.value === undefined)) return;

                            if (e.target.checked) {
                                var propsValue = props.value == null || props.value === undefined ? 0 : props.value;
                                onChange(propsValue | enumType[t] as number);
                            } else if (props.value !== null && props.value !== undefined) {
                                onChange(props.value ^ enumType[t] as number);
                            }
                        }}
                        checked={((props.value ?? 0) & enumType[t] as number) > 0}
                    />
                    {nameToDisplayConverter ? nameToDisplayConverter(t) : t}
                </label>
            </div>
        ))

    );
}